export default "__VITE_ASSET__1301472d__"